var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.backToApp}},[_vm._v("App")])}
var staticRenderFns = []

export { render, staticRenderFns }